const data = {
    "dati-mercato": {
      label: "Dati identificativi del mercato",
      description: "Qui trovi il nome della Società che hai scelto per la fornitura di energia elettrica (Servizio Elettrico Nazionale) e il tipo di mercato che, nel tuo caso, è \"di maggior tutela\".<br>Si chiama così perchè i prezzi dell'energia elettrica vengono stabiliti, modificati e aggiornati ogni tre mesi dall'Arera.",
      labelKeywords: ["dati", "dato", "identificativi", "identificativo", "mercato"],
      contentKeywords: ["dati", "dato", "identificativi", "identificativo", "mercato"],
      img: "./images/01-testata-01-intestazione-01-datimercato.jpg",
      imgDescription: "Immagine che raffigura il primo foglio della bolletta con evidenziato il logo di Servizio Elettrico Nazionale."
    },

    "icona-fornitura": {
      label: "Icona fornitura",
      description: "L'icona della lampadina ti aiuta a riconoscere immediatamente la bolletta dell'energia elettrica.",
      labelKeywords: ["icona", "fornitura"],
      contentKeywords: ["icona", "fornitura"],
      img: "./images/01-testata-01-intestazione-02-iconafornitura.jpg",
      imgDescription: "Dettaglio del primo foglio della bolletta che mette in evidenza icona di una lampadina."
    },

    "recapito-bolletta": {
      label: "Recapito bolletta",
      description: "È l'indirizzo al quale inviamo la bolletta, può quindi essere diverso da quello di fornitura (per esempio, se hai una seconda casa o una casa in affitto). Puoi cambiarlo in qualsiasi momento semplicemente accedendo all'<a href='https://www.servizioelettriconazionale.it/it-IT?access=f&intcid=email-SEN-clienti- ' target='_blank'>Area Clienti</a>.",
      labelKeywords: ["recapito", "bolletta"],
      contentKeywords: ["recapito", "bolletta"],
      img: "./images/01-testata-01-intestazione-03-recapitobolletta.jpg",
      imgDescription: "Dettaglio della parte superiore del primo foglio della bolletta che evidenzia i dati di recapito dell'intestatario (nome, cognome, indirizzo)."
    }
}

export default data;